import axios from "axios";
const bffInstance = axios.create({
  baseURL: process.env.VUE_APP_UMS,
});
const ufsInstance = axios.create({
  baseURL: process.env.VUE_APP_UFS,
});
bffInstance.interceptors.response.use((res) => {
  if (res.data.success) {
    return Promise.resolve(res);
  }
  return Promise.reject(res);
});

export function quickRegister(params) {
  return bffInstance.post("/ums-service/userNewsLetter", params);
}
export function getQuestions(params) {
  return ufsInstance.post("/account/unsubscribeQA", params);
}
export function submitQuestions(params) {
  return ufsInstance.post("/account/unsubscribe", params);
}

export function resubscribe(params) {
  return ufsInstance.post("/account/resubscribe", params);
}